export default __webpack_public_path__ + "static/media/alertIconYellow.81a7a440.svg";